/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LifeCycleStage } from './LifeCycleStage';
import {
	LifeCycleStageFromJSON,
	LifeCycleStageFromJSONTyped,
	LifeCycleStageToJSON,
} from './LifeCycleStage';

/**
 * An transaction the captures the current lifecycle stage of the record
 * @export
 * @interface LifeCycleTransaction
 */
export interface LifeCycleTransaction {
	/**
	 * A transaction id that can be correlated across multiple data systems
	 * @type {string}
	 * @memberof LifeCycleTransaction
	 */
	transactionId?: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof LifeCycleTransaction
	 */
	triggerRID?: string;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof LifeCycleTransaction
	 */
	userRID?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof LifeCycleTransaction
	 */
	transactionDateUtc?: Date;
	/**
	 *
	 * @type {LifeCycleStage}
	 * @memberof LifeCycleTransaction
	 */
	stage?: LifeCycleStage;
}

/**
 * Check if a given object implements the LifeCycleTransaction interface.
 */
export function instanceOfLifeCycleTransaction(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function LifeCycleTransactionFromJSON(json: any): LifeCycleTransaction {
	return LifeCycleTransactionFromJSONTyped(json, false);
}

export function LifeCycleTransactionFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): LifeCycleTransaction {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		transactionId: !exists(json, 'transactionId') ? undefined : json['transactionId'],
		triggerRID: !exists(json, 'triggerRID') ? undefined : json['triggerRID'],
		userRID: !exists(json, 'userRID') ? undefined : json['userRID'],
		transactionDateUtc: !exists(json, 'transactionDateUtc')
			? undefined
			: new Date(json['transactionDateUtc']),
		stage: !exists(json, 'stage') ? undefined : LifeCycleStageFromJSON(json['stage']),
	};
}

export function LifeCycleTransactionToJSON(value?: LifeCycleTransaction | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		transactionId: value.transactionId,
		triggerRID: value.triggerRID,
		userRID: value.userRID,
		transactionDateUtc:
			value.transactionDateUtc === undefined
				? undefined
				: value.transactionDateUtc.toISOString(),
		stage: LifeCycleStageToJSON(value.stage),
	};
}
